import { getAllStationOptions } from "@/api/station";

const state = {
    stationOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.stationOptions = data;
    },
};

const actions = {
    async getAllStationOptions({ commit }) {
        let res = await getAllStationOptions();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/station.js